import React from 'react';
import clsx from 'clsx';

const NoPageSelectedValidation = () => 
    (
        <div style={{height: '100%',width: '100%', borderRadius: '0.5vw', backgroundColor: 'rgb(207, 216, 224)', display: 'flex', alignItems: 'center',justifyContent: 'center'}}>
           <span style={{marginBottom: '4vw'}} className={clsx('red')}>No Page has been selected</span> 
            
        </div>
            
    )

export default NoPageSelectedValidation;

